import { render, staticRenderFns } from "./TgToolbarTitle.vue?vue&type=template&id=09f106cf"
import script from "./TgToolbarTitle.vue?vue&type=script&lang=js"
export * from "./TgToolbarTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports